import { UseAppContainer } from "./styled/common";

const UseApp = ({ setIsUseApp, message }) => {
  const hideUseApp = () => {
    localStorage.setItem("hideUseApp", true);
    sessionStorage.setItem("hideUseApp", true);

    setIsUseApp(false);
  };

  const openMonoti = async (scheduleNo = null) => {
    const os = getOS();

    if (os === "android") {
      const intentUrl = getAndroidIntentUrl(`?scheduleNo=${scheduleNo}`);
      const storeUrl = getAppStoreUrl();
      let appOpened = false;

      const onVisibilityChange = () => {
        appOpened = true;
        document.removeEventListener("visibilitychange", onVisibilityChange);
      };

      document.addEventListener("visibilitychange", onVisibilityChange);
      window.location.href = intentUrl;

      setTimeout(() => {
        document.removeEventListener("visibilitychange", onVisibilityChange);

        if (!appOpened && storeUrl) {
          window.location.href = storeUrl;
        }
      }, 1500);
    } else {
      const appOpened = await openApp(`?scheduleNo=${scheduleNo}`);
      if (!appOpened) {
        const url = getAppStoreUrl();
        if (url) {
          window.open(url, "_blank");
        }
      }
    }

    hideUseApp();
  };

  return (
    <UseAppContainer onClick={(e) => e.target === e.currentTarget && hideUseApp()}>
      <div className="modal">
        <div className="info">
          <img src="/img/logo.png" alt="monoti" />
          <div>
            <h2>{message.title}</h2>
            <p>{message.info}</p>
          </div>
        </div>
        <div className="actions">
          <button onClick={() => openMonoti()}>모노티로 시작하기</button>
          <button onClick={() => hideUseApp()}>모바일 웹에서 볼래요</button>
        </div>
      </div>
    </UseAppContainer>
  );
};

export default UseApp;
